import { createFeatureSelector } from '@ngrx/store';
import {
  MassInsertionState,
  TicketEditState,
  TicketResolveState,
  TicketsActionsState,
  TicketsSearchState,
} from '../models/tickets.models';
import { TicketEditReducer } from './edit-ticket.reducer';
import { MassInsertionReducer } from './mass-insertion.reducer';
import { TicketResolveReducer } from './ticket-resolve.reducer';
import { TicketActionsReducer } from './tickets-actions.reducer';
import { TicketsReducer } from './tickets-search.reducer';

export const featureTicketsName = 'Tickets';

export interface DragonflyTicketsState {
  tickets: TicketsSearchState;
  editTicket: TicketEditState;
  ticketResolve: TicketResolveState;
  ticketActions: TicketsActionsState;
  massInsertion: MassInsertionState;
}

export const moduleTicketsReducers = {
  tickets: TicketsReducer,
  editTicket: TicketEditReducer,
  ticketResolve: TicketResolveReducer,
  ticketActions: TicketActionsReducer,
  massInsertion: MassInsertionReducer,
};

export const getDragonflyTicketsState = createFeatureSelector<DragonflyTicketsState>(featureTicketsName);
